import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { spreadDangerousChildren } from "../utils/spreadDangerousChildren";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

/**
 * @param color, variants 'grey95', 'white',
 * 'grey50', 'grey60','grey40', 'scarlet', 'sienna', 'beeline', 'green', 'contentAccent1' are deprecated, transition is
 * grey95 - textIconElementPrimary,
 * grey60 - textIconElementSecondary,
 * grey50 - textIconElementTertiary,
 * grey40 - textIconElementTertiary,
 * white - textIconElementPrimaryInvert,
 * sienna - textIconElementSecondary,
 * scarlet - textIconElementError,
 * magenta - accent04
 * contentAccent1 - textIconElementAccent
 * green - textIconElementSuccess
 * @param crossOutColor variants 'magenta', 'scarlet' are deprecated,
 * transition is
 * scarlet - textIconElementError,
 * magenta - accent04
 */
export var Text = /*#__PURE__*/memo(function (_ref) {
  var _cn, _cn2, _cn3;
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'textIconElementPrimary' : _ref$color,
    isUpperCase = _ref.isUpperCase,
    size = _ref.size,
    children = _ref.children,
    _ref$tagType = _ref.tagType,
    Tag = _ref$tagType === void 0 ? 'span' : _ref$tagType,
    isEllipsis = _ref.isEllipsis,
    isCrossedOut = _ref.isCrossedOut,
    crossOutColor = _ref.crossOutColor,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Text' : _ref$testName,
    extraAttributes = _ref.extraAttributes,
    className = _ref.className,
    _ref$allowHtml = _ref.allowHtml,
    allowHtml = _ref$allowHtml === void 0 ? true : _ref$allowHtml;
  return isCrossedOut ? /*#__PURE__*/React.createElement("div", {
    className: cn('text', (_cn = {}, _defineProperty(_cn, "text--".concat(size), Boolean(size)), _defineProperty(_cn, "text--".concat(color), Boolean(color)), _defineProperty(_cn, 'text--uppercase', isUpperCase), _defineProperty(_cn, 'text--ellipsis', isEllipsis), _cn), className),
    "data-component": testName
  }, /*#__PURE__*/React.createElement(Tag, _extends({}, extraAttributes, {
    className: cn({
      'text--ellipsis': isEllipsis
    })
  }, allowHtml ? spreadDangerousChildren(children) : {
    children: children
  })), /*#__PURE__*/React.createElement("span", {
    className: cn('text__crossing', (_cn2 = {}, _defineProperty(_cn2, "text__crossing--".concat(color), Boolean(color)), _defineProperty(_cn2, "text__crossing--".concat(crossOutColor), Boolean(crossOutColor)), _cn2))
  })) : /*#__PURE__*/React.createElement(Tag, _extends({}, extraAttributes, {
    className: cn('text', (_cn3 = {}, _defineProperty(_cn3, "text--".concat(size), Boolean(size)), _defineProperty(_cn3, "text--".concat(color), Boolean(color)), _defineProperty(_cn3, 'text--uppercase', isUpperCase), _defineProperty(_cn3, 'text--ellipsis', isEllipsis), _cn3), className),
    "data-component": testName
  }, allowHtml ? spreadDangerousChildren(children) : {
    children: children
  }));
});
Text.displayName = Text.name;